export enum TeaserLinksMargins {
  CenteredSlim = 'Centered slim',
}

export enum TeaserLinksLayouts {
  Copy = 'Copy',
  Image = 'Image',
  Icon = 'Icon',
}
